import classnames from 'classnames';
import React, { FunctionComponent } from 'react';
import styles from './DonationAmountSelector.scss';

type HideDonationAmountCheckboxProps = {
  checked: boolean;
  labelText: string;
  onChange: () => void;
};

export const HideDonationAmountCheckbox: FunctionComponent<HideDonationAmountCheckboxProps> = ({
  checked,
  labelText,
  onChange,
}) => {
  return (
    <div className="jg-form-group jg-space-mbsm">
      <input
        className={classnames('jg-checkbox', styles.hideAmountCheckbox)}
        type="checkbox"
        id="hideDonationAmount"
        checked={checked}
        onChange={onChange}
      />
      <label htmlFor="hideDonationAmount">{labelText}</label>
    </div>
  );
};
